import request from '@/modules/request'
import qs from 'qs'

// 登录第一次
export const loginPassword = (params) => {
  let query = qs.stringify(params, { indices: false })
  return request.post(`/auth/oauth2/by-password?${query}`)
}
// 登录第二次
export const login = (params) => {
  let query = qs.stringify(params, {indices: false})
  return request.post(`/auth/oauth2/token?${query}`)
}
export const checkToken = (token) => {
  return request.get(`/auth/token/check_token?token=${token}`)
}

// 退出登录
export const loginOut = () => {
  return request.post('/auth/token/logout')
}

// 获取登录验证码
export const getSMSCode = (mobile) => {
  return request.post(`/auth/oauth2/sms?mobile=${mobile}`);
}

// 短信登录验证
export const validateSMS = (params) => {
  let query = qs.stringify(params, {indices: false})
  return request.post(`/auth/oauth2/validate-sms?${query}`);
}

// 获取权限
export const getAuthenticated = () => {
  return request.get('/auth/token/authenticated');
};

// 获取图片验证
export const getCode = (data) => {
  return request.get('/code/create', data)
}

// 获取手机短信图片验证
export const getCodeByPhone = (data) => {
  return request.get('/public/block-captcha', data)
}

// 图形验证码核对
export const reqCheck = (data) => {
  let query = qs.stringify(data, { indices: false })
  return request.post(`/code/check?${query}`)
}
// 获取用户信息
export const getUserData = () => {
  return request.get('/auth/authenticated')
}

// 获取图形验证码
export const getPublicCaptcha = () => {
  return request.get('/public/captcha')
}

// --------------------------------------------

// 获取用户自定义配置
export const getExtend = () => {
  return request.get('/enterprise-extend')
}
// 保存用户自定义配置
export const updateExtend = (params) => {
  return request.post('/enterprise-extend', params)
}

// 富文本的图片上传
export const editorUpload = (params) => {
  return request.post('/core/authenticated/rich-text-temp-files-upload', params)
}

//获取未读消息数量
export function readNumber(status) {
  return request.get(`/sys-messages/message-viewed-total?status=${status}`)
}

export function readList(params) {
  return request.get('/sys-messages/message-viewed-limit', { params: params })
}

//已读和未读
export function isRead(id) {
  return request.put(`/sys-messages/${id}`)
}

// app最新版本检测
export function lastApk(params) {
  return request.get('/public/system-apk-versions/last', { params })
}
/**
 * 获取最新的apkId
 * @returns
 */
export function getNewApkId() {
  return request.get('/enterprise-common/new');
}
// 修改密码
export async function modifyPassWord(params, token) {
  request.interceptors.request.use((config) => {
    config.headers.authorization = 'Bearer ' + token
    return config
  })
  return request.put('/authenticated/update-password', params)
}

// 获取全部用户
export function getAllUserList(params) {
  return request.get('/enterprise-user/list', { params })
}
// 获取部门和用户
export function getUnitPersonByPopover(formData) {
  return request.get('/enterprise-user/next/department/user', { params: formData })
}
// 获取相关方用户列表
export function getSubcontractorPersonByPopover(formData){
  return request.get('/subcontractor/all-list',{ params: formData })
}

/**
 * 获取图形验证码
 * @returns
 */
export function getImgCaptcha() {
  return request.get('/public/img-captcha')
}

/**
 * 验证图形验证码
 * @param {Object} params
 * @param
 * @returns
 */
export function verifyImgCaptcha(params) {
  return request.post('/public/img-captcha', params)
}

/**
 * 获取手机验证码
 * @param {Object} params

 * @returns
 */
export function getPhoneCaptcha(params) {
  return request.get('/public/phone-captcha', {params})
}

/**
 * 验证手机验证码
 * @param {Object} params
 * @returns
 */
export function verifyPhoneCaptcha(params) {
  return request.post('/public/phone-valid', params)
}

/**
 *  登录页  忘记密码
 *  * @param {string} id
 * @param {string} phone
 * @param {Object} params
 * @returns
 */
export function resetUserPassword(phone, params) {
  return request.put(`/public/${phone}/password-forget`, params)
}

/**
 * 通过id查询用户信息
 * @param {string} id 用户ID
 * @returns
 */
export function getUserInfoById(id) {
  return request.get(`/enterprise-user/${id}`)
}

// 下载文件
export function getUploadFileInfo(formData) {
  return request.post('/sys-file/upload-by-sts',formData);
}
export function downloadFile(formData) {
  return request.get(`/sys-file/download/${formData.id}`, { responseType: 'blob'});
}
